import { Link } from "react-router-dom";
import { BlockImage, EditableImage, T } from "@/site/Editable";
import { useSite } from "@/site/SiteContext";

const STEPS = [1, 2, 3, 4, 5];

const Hero = () => (
  <section className="hs-hero" data-testid="home-hero">
    <BlockImage k="home.hero.image" alt="Haus A interior" className="hs-hero__img" />
    <div className="hs-hero__shade" aria-hidden="true" />
    <div className="hs-hero__content">
      <T k="home.hero.title" as="h1" className="hs-hero__title hs-rise" multiline={false} />
      <T k="home.hero.tagline" className="hs-hero__tag hs-rise hs-d2" multiline={false} />
    </div>
  </section>
);

const Intro = () => (
  <section className="hs-band" data-testid="home-intro">
    <div className="hs-ornament hs-ornament--top" aria-hidden="true" />
    <div className="hs-band__grid">
      <BlockImage k="home.intro.image_left" alt="Interior detail" className="hs-frame hs-band__img hs-band__img--left hs-fade" />
      <div className="hs-band__text hs-fade">
        <T k="home.intro.heading" as="h2" className="hs-title" multiline={false} />
        <T k="home.intro.body1" className="hs-band__body" />
        <T k="home.intro.body2" className="hs-band__body" />
        <Link to="/contact" className="hs-text-link" data-testid="home-schedule-consult-link"><T k="home.intro.cta" as="span" multiline={false} /></Link>
      </div>
      <BlockImage k="home.intro.image_right" alt="Dining room" className="hs-frame hs-band__img hs-band__img--right hs-fade" />
    </div>
    <div className="hs-ornament hs-ornament--bottom" aria-hidden="true" />
  </section>
);

const Process = () => (
  <section className="hs-process" data-testid="home-process">
    <div className="hs-wrap">
      <T k="home.process.eyebrow" className="hs-eyebrow" multiline={false} />
      <T k="home.process.heading" as="h2" className="hs-title" multiline={false} />
      <T k="home.process.intro" className="hs-process__intro" />
      <ol className="hs-steps">
        {STEPS.map((n) => (
          <li key={n} className="hs-step hs-fade" data-testid={`process-step-${n}`}>
            <span className="hs-step__num">{String(n).padStart(2, "0")}</span>
            <T k={`home.process.step${n}.title`} as="h3" className="hs-step__title" multiline={false} />
            <T k={`home.process.step${n}.body`} className="hs-step__body" />
          </li>
        ))}
      </ol>
    </div>
  </section>
);

const Work = () => {
  const { content, saveProject } = useSite();
  return (
    <section className="hs-cream hs-work" data-testid="home-selected-work">
      <div className="hs-wrap">
        <T k="home.work.heading" as="h2" className="hs-title hs-title--dark" multiline={false} />
        <div className="hs-work__grid">
          {content.projects.slice(0, 3).map((p) => (
            <Link to="/portfolio" key={p.id} className="hs-work__item hs-fade" data-testid={`home-work-${p.id}`}>
              <EditableImage src={p.cover} alt={p.title} className="hs-frame hs-frame--light" onReplace={(cover) => saveProject(p.id, { cover })} testId={`home-work-cover-${p.id}`} />
              <span className="hs-caption">{p.title}</span>
            </Link>
          ))}
        </div>
        <Link to="/portfolio" className="hs-btn" data-testid="home-view-portfolio-button"><T k="home.work.cta" as="span" multiline={false} /></Link>
      </div>
    </section>
  );
};

export default function Home() {
  return (<><Hero /><Intro /><Process /><Work /></>);
}
